import { create } from 'zustand';
import { getComponentStore } from '../../utils/componentStoreRegistry';

const createSequentialFormStore = () => create((set, get) => ({
  loaded: false,
  save: null,
  registerSave: (fn) => set({ save: fn }),
  unregisterSave: () => set({ save: null }),
}));

export function getSequentialFormStore(componentId) {
  return getComponentStore('sequential-form', componentId, createSequentialFormStore);
}
